<script>
import './nr-icon-button.scss'
import NrButton, {
  SIZES as NrButtonSizes,
  VARIANTS as NrButtonVariants
} from '../NrButton/nr-button.vue'
import NrIcon from '../NrIcon/NrIcon.vue'

export const SIZES = ['large', ...NrButtonSizes]
export const VARIANTS = NrButtonVariants

const DEFAULT_ICON = {
  name: 'archive',
  type: 'regular'
}

export default {
  components: { NrButton, NrIcon },
  props: {
    icon: {
      type: Object,
      default() {
        return DEFAULT_ICON
      }
    },
    size: {
      type: String,
      default: 'normal'
    },
    variant: {
      type: String,
      default: 'filled-primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classnames() {
      return ['nr-icon-button', `size--${this.size}`]
    },
    name() {
      return Object.assign(DEFAULT_ICON, this.icon).name
    },
    type() {
      return Object.assign(DEFAULT_ICON, this.icon).type
    },
    attrs() {
      const { icon, ...props } = this.$props // eslint-disable-line
      return { ...props, ...this.$attrs }
    }
  }
}
</script>

<template>
  <NrButton :class="classnames" v-bind="attrs">
    <NrIcon :name="name" :iconType="type" />
  </NrButton>
</template>
